<template>
  <div>
    <div class="screen"  v-if="root.device!='phone'">
            <div class="row header">
                <topHeader :title="'歌莉娅运营数据看板'"/>
            </div>
            <div class="row container">
                <div  class="row" >
                    <div class="col col-1 rv">
                        <div class="row1 row-left">
                            <div class="col box1 box1-right" >
                                <cusbox txt="近一月销售趋势">
                                        <div  class="container1-chart" v-if="salesVolumeStatus">
                                            <lineChart :data="salesVolumedata" :datelist="datelist2" class="container1-chart-line"/>
                                        </div>
                                        <dv-loading v-if="!salesVolumeStatus">Loading...</dv-loading>
                                </cusbox>
                            </div>
                            <div class="col box1">
                                <cusbox txt="近一月拉新趋势">
                                        <div v-if="registerMemberCountStatus" class="container1-chart">
                                            <barChart :data="registerMemberCountdata" class="container1-chart-line" />
                                        </div>
                                        <dv-loading v-if="!registerMemberCountStatus">Loading...</dv-loading>
                                </cusbox>
                            </div>
                        </div>
                        <div class="row1 row-center">
                            <div class="col box1 box1-right">
                                <cusbox txt="本月店铺销售 TOP20"> 
                                    <scrollBoard v-if="shopRankStatus" :config="shopRankdata" class="board" />
                                    <dv-loading v-if="!shopRankStatus">Loading...</dv-loading>
                                </cusbox>
                            </div>
                            <div class="col box1">
                                <cusbox txt="本月导购销售 TOP50">
                                    <scrollBoard v-if="guideRankStatus" :config="guideRankdata" class="board" />
                                    <dv-loading v-if="!guideRankStatus">Loading...</dv-loading> 
                                </cusbox>
                            </div>
                        </div>
                        <div class="row1">
                            <div class="col box1">
                                <cusbox txt="本月商品销量 TOP50">
                                    <scrollBoard v-if="goodsRankStatus" :config="goodsRankdata" class="board" />
                                    <dv-loading v-if="!goodsRankStatus">Loading...</dv-loading>
                                </cusbox>
                            </div>
                        </div>
                    </div>
                    <div class="col col-2">
                        <div class="col box2">
                                <cusbox :isTitle="false">
                                    <div v-if="salesVolumeStatus" class="box2-top">
                                        <div class="container1-title"><span>本月销售总额</span></div>
                                        <div class="container1-value"><span>{{saleMoneydata}}</span></div>
                                        <div class="container1-title"><span>今日销售总额</span></div>
                                        <DigitalFlop v-if="salesVolumeStatus" class="container1-center-box-digital" :config="indexTodaydata.saleVolume"/>
                                        <div class="container1-content">
                                                <ul>
                                                    <li>成交单数</li>
                                                    <li><span>{{indexTodaydata.dealNumber}}</span></li>
                                                </ul>
                                                <ul>
                                                    <li>客单价</li>
                                                    <li><span>{{indexTodaydata.averageTransactionValue}}</span></li>
                                                </ul>
                                                <ul>
                                                    <li>门店客流量</li>
                                                    <li><span>{{indexTodaydata.customFlow}}</span></li>
                                                </ul>
                                                <ul>
                                                    <li>门店成交率</li>
                                                    <li><span>{{indexTodaydata.closeRate}}</span></li>
                                                </ul>
                                        </div>
                                    </div>
                                    <div v-if="salesVolumeStatus" class="box2-bottom">
                                        <div class="container1-chart">
                                            <custitle :txt="'门店分布及本月销售额'" :rightShow="false"/>
                                            <mapChart :data="storeSaledata" class="container1-chart-map"/>
                                        </div>
                                    </div>
                                    <dv-loading v-if="!salesVolumeStatus">Loading...</dv-loading>
                            </cusbox>
                        </div>
                    </div>
                    <div class="col col-3 rv">
                        <div class="row3">
                            <div class="col box3">
                                <cusbox txt="本月销售占比">
                                    <div v-if="memberTypeRateStatus" class="container1-right-box-chart">
                                        <pieChart :data="guideAndMemberSaledata" class="container1-right-box-chart-pie"/>
                                        <pieChart :data="onAndOffSaledata" class="container1-right-box-chart-pie"/>
                                    </div>
                                    <dv-loading v-if="!memberTypeRateStatus">Loading...</dv-loading>
                                </cusbox>
                            </div>
                        </div>
                        <div class="row3 row-center">
                            <div class="col box3 box3-center">
                                <cusbox txt="本月新增投产">
                                    <scrollBoard v-if="produceAndSaleStatus" :config="produceAndSaledata" class="container1-right-box-board" />
                                    <dv-loading v-if="!produceAndSaleStatus">Loading...</dv-loading> 
                                </cusbox>
                            </div>
                        </div>
                        <div class="row3">
                            <div class="col box3">
                                <cusbox txt="渠道大区销售占比">
                                    <radiusPieChart v-if="areaSaleRateStatus" :data="areaSaleRatedata"  class="container2-box-pie"/>
                                    <dv-loading v-else>Loading...</dv-loading> 
                                </cusbox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         <bigOrder :data="bigSaledata" v-if="bigSaleStatus" />
            <fireworks v-if="fireworksStatus" :boxHeight="'100%'" :boxWidth="'100%'" :autoData ="fireworksStatus" />
    </div>

    <div class="screen" v-else>   
          <div class="header">
              <!-- 歌莉娅运营数据看板    -->
              <mhead   title="歌莉娅运营数据看板"/> 
          </div>
          <div class="content">
             <div class="mcontent">
                    <mobile class="device_phone ppd notransform">
                            <div class="moblieline h850">      
                                <cusbox :isTitle="false">
                                        <div v-if="salesVolumeStatus" class="box2-top">
                                            <div class="container1-title"><span>本月销售总额</span></div>
                                            <div class="container1-value"><span>{{saleMoneydata}}</span></div>
                                            <div class="container1-title"><span>今日销售总额</span></div>
                                            <DigitalFlop v-if="salesVolumeStatus" class="container1-center-box-digital" :config="indexTodaydata.saleVolume"/>
                                            <div class="container1-content">
                                                    <ul>
                                                        <li>成交单数</li>
                                                        <li><span>{{indexTodaydata.dealNumber}}</span></li>
                                                    </ul>
                                                    <ul>
                                                        <li>客单价</li>
                                                        <li><span>{{indexTodaydata.averageTransactionValue}}</span></li>
                                                    </ul>
                                                    <ul>
                                                        <li>门店客流量</li>
                                                        <li><span>{{indexTodaydata.customFlow}}</span></li>
                                                    </ul>
                                                    <ul>
                                                        <li>门店成交率</li>
                                                        <li><span>{{indexTodaydata.closeRate}}</span></li>
                                                    </ul>
                                            </div>
                                        </div>
                                        <div v-if="salesVolumeStatus" class="box2-bottom">
                                            <div class="container1-chart">
                                                <custitle :txt="'门店分布及本月销售额'" :rightShow="false"/>
                                                <mapChart :data="storeSaledata" class="container1-chart-map"/>
                                            </div>
                                        </div>
                                        <dv-loading v-if="!salesVolumeStatus">Loading...</dv-loading>
                                </cusbox>
                            </div>
                           <div class="moblieline h450">                                    
                                <cusbox txt="近一月销售趋势">                          
                                        <div  class="container1-chart" v-if="salesVolumeStatus">
                                            <lineChart :data="salesVolumedata" :datelist="datelist2" class="container1-chart-line"/>
                                        </div>
                                        <dv-loading v-if="!salesVolumeStatus">Loading...</dv-loading>
                                </cusbox>                                        
                            </div>
                            <div class="moblieline h450">                                    
                               <cusbox txt="近一月拉新趋势">
                                        <div v-if="registerMemberCountStatus" class="container1-chart">
                                            <barChart :data="registerMemberCountdata" class="container1-chart-line" />
                                        </div>
                                        <dv-loading v-if="!registerMemberCountStatus">Loading...</dv-loading>
                                </cusbox>                                      
                            </div>
                            <div class="moblieline h450 mh1">                                    
                               <cusbox txt="本月店铺销售 TOP20"> 
                                    <scrollBoard v-if="shopRankStatus" :config="shopRankdata" class="board" />
                                    <dv-loading v-if="!shopRankStatus">Loading...</dv-loading>
                                </cusbox>                                     
                            </div>
                            <div class="moblieline h450 mh2">                                    
                               <cusbox txt="本月导购销售 TOP50">
                                    <scrollBoard v-if="guideRankStatus" :config="guideRankdata" class="board" />
                                    <dv-loading v-if="!guideRankStatus">Loading...</dv-loading> 
                                </cusbox>                                     
                            </div>
                            <div class="moblieline h450 xl_top50 mh3" >                                    
                                <cusbox txt="本月商品销量 TOP50">
                                    <scrollBoard v-if="goodsRankStatus" :config="goodsRankdata" class="board" />
                                    <dv-loading v-if="!goodsRankStatus">Loading...</dv-loading>
                                </cusbox>                                  
                            </div>
                             <div class="moblieline h850 xl_top50">                                    
                                <cusbox txt="本月销售占比">
                                    <div v-if="memberTypeRateStatus" class="container1-chart-p">
                                        <pieChart :data="guideAndMemberSaledata" class="container1-chart-pie"/>
                                        <pieChart :data="onAndOffSaledata" class="container1-chart-pie"/>
                                    </div>
                                    <dv-loading v-if="!memberTypeRateStatus">Loading...</dv-loading>
                                </cusbox>                            
                            </div>   
                             <div class="moblieline h450 xl_top50 mh4" > 
                                <cusbox txt="本月新增投产">
                                    <scrollBoard v-if="produceAndSaleStatus" :config="produceAndSaledata" class="container1-right-box-board" />
                                    <dv-loading v-if="!produceAndSaleStatus">Loading...</dv-loading> 
                                </cusbox>
                             </div>
                             <div class="moblieline h450 " > 
                                <cusbox txt="渠道大区销售占比">
                                <radiusPieChart v-if="areaSaleRateStatus" :data="areaSaleRatedata"  class="container2-box-pie"/>
                                <dv-loading v-else>Loading...</dv-loading> 
                               </cusbox>
                             </div>
                           
                    </mobile>
             </div>
          </div>
           <!-- <bigOrder :data="bigSaledata" v-if="bigSaleStatus" />
            <fireworks v-if="fireworksStatus" :boxHeight="'100%'" :boxWidth="'100%'" :autoData ="fireworksStatus" /> -->
    </div>
           
  </div>
</template>

<script>
    import mhead from "@/components/cuscom/mhead"
    import wrapper from "@/components/cuscom/wrapper.vue";
        import topHeader from "@/components/topHeader"
    // import { deepMerge } from '@jiaminghi/charts/lib/util/index'
    // import { deepClone } from '@jiaminghi/c-render/lib/plugin/util'   
    import cusbox from "@/components/datav/cusbox"
    import custitle from "@/components/vip/custitle"
    import DigitalFlop from "@/components/datav/digitalFlop/main2"
    import barChart from "@/components/datav/barChart/main1"
    import lineChart from "@/components/datav/lineChart/main1"
    import pieChart from "@/components/datav/pieChart/main"
    import radiusPieChart from "@/components/datav/pieChart/main1"
    import mapChart from "@/components/datav/mapChart/main"
    import scrollBoard from "@/components/datav/scrollBoard/main"
    import boardNum from "@/components/datav/boardNum/main"
    import bigOrder from "@/components/datav/bigOrder/main"
    import fireworks from "@/components/datav/fireworks/main"
    import {areaSaleRate, goodsRank, guideRank,indexToday,
            memberTypeRate,produceAndSale,productTest,registerMemberCount,
            salesVolume,shopRank,saleMoney,storeSale,bigSale} from '@/api/operate.js'
    import {numberformatter} from '@/utils/numberUtil.js'
    export default {
        inject:['root'],
        data () {
            return {
                timer:null,
                timer1:null,
                datelist2:[],
                mhconfig: 0,
                areaSaleRateStatus: false,
                goodsRankStatus: false,
                guideRankStatus:false,
                indexTodayStatus:false,
                memberTypeRateStatus:false,
                produceAndSaleStatus:false,
                productTestStatus: false,
                registerMemberCountStatus: false,
                saleStandardRateStatus: false,
                salesVolumeStatus: false,
                shopRankStatus: false,
                bigSaleStatus: false,
                fireworksStatus: false,
                areaSaleRatedata:{},
                salesVolumedata: [],
                goodsRankdata:{},
                productTestdata:{},
                produceAndSaledata:{},
                guideRankdata:{},
                shopRankdata:{},
                guideAndMemberSaledata:{},
                onAndOffSaledata:{},
                onlineRate:{},
                offlineRate:{},
                indexTodaydata:{},
                storeSaledata:{},
                bigSaledata:{},
                saleMoneydata:0,
                totalSalesVolume: 0,
                FLAG:0,
                templateAreaSaleRatedata:[],
                images:[require('@/assets/no1.png'),require('@/assets/no2.png'),require('@/assets/no3.png')]
            }
        },
        mounted() {
            this.getAll();
            this.timer = setInterval(this.getAll, 120000);
        },
        methods: {
        
            getAll(){
                const _this = this
                areaSaleRate().then(function(result){
                         _this.areaSaleRateStatus = true
                      setTimeout(function(){
                               _this.areaSaleRatedata = result.data 
                      },0)
                })
                goodsRank().then(function(result){
                    _this.goodsRankdata.header=['排名','图片', '货号', '品类','销量', '支付买家数', '支付金额','库存']
                    _this.goodsRankdata.data = []
                    _this.goodsRankdata.columnWidth = [50,50,100]
                    _this.goodsRankdata.headerClass = 'header-product-sale'
                    _this.goodsRankdata.ceilClass = 'ceil-product-sale'
                    _this.goodsRankdata.align = ['center','center','left','center','center','center','center','center']
                    _this.goodsRankdata.headerBGC ='#03083A'
                    _this.goodsRankdata.oddRowBGC ='rgba(0,0,0,0~1)'
                    _this.goodsRankdata.evenRowBGC ='#03083A'
                    if(result){
                        result.data.list.forEach(function(item){
                            var imageUrl = JSON.parse(item.imageUrl)
                            if(imageUrl == null){
                                imageUrl = ['http://pim.gloria.com.cn/productImg/nopic.gif?x-oss-process=image/resize,w_78']
                            }
                            if(item.rank <= 3 ){
                                _this.goodsRankdata.data.push(["<img class='boardImg' src='" +_this.images[item.rank-1] +"' />","<img src='"+imageUrl[0]+"'/>",item.itemId,item.goodsClass,item.sales,item.buyerNumber,item.saleVolume,item.stock])
                            }else {
                                _this.goodsRankdata.data.push([item.rank,"<img src='"+imageUrl[0]+"'/>",item.itemId,item.goodsClass,item.sales,item.buyerNumber,item.saleVolume,item.stock])
                            }
                        })
                    }
                    _this.goodsRankStatus = true;
                })
                guideRank().then(function(result){
                    _this.guideRankdata.header= ['排名', '店铺', '导购','销售额']
                    _this.guideRankdata.data = []
                    _this.guideRankdata.rowNum = 7
                    _this.guideRankdata.columnWidth = [50,130]
                    _this.guideRankdata.headerClass = 'header-guide-sale'
                    _this.guideRankdata.ceilClass = 'ceil-guide-sale'
                    _this.guideRankdata.align = ['center','left','left','right']
                    _this.guideRankdata.headerBGC ='#03083A'
                    _this.guideRankdata.oddRowBGC ='rgba(0,0,0,0~1)'
                    _this.guideRankdata.evenRowBGC ='rgba(0,0,0,0~1)'
                    if(result){
                        result.data.list.forEach(function(item){
                            if(item.rank <= 3 ){
                                _this.guideRankdata.data.push(["<img class='boardImg' src='" +_this.images[item.rank-1] +"' />",item.shopName,item.guideName,item.saleVolume])
                            }else {
                                _this.guideRankdata.data.push([item.rank,item.shopName,item.guideName,item.saleVolume])
                            }
                        })
                    }
                    _this.guideRankStatus = true;
                })
                indexToday().then(function(result){
                    if(result){
                        _this.indexTodaydata.saleVolume = Math.ceil(result.data.saleVolume)
                        _this.indexTodaydata.customFlow = result.data.customFlow
                        _this.indexTodaydata.dealNumber = result.data.dealNumber
                        _this.indexTodaydata.averageTransactionValue = Math.ceil(result.data.averageTransactionValue)
                        _this.indexTodaydata.closeRate = (result.data.closeRate).toFixed(2)+"%"
                    }
                    _this.indexTodayStatus = true;
                })
                saleMoney().then(function(result){
                    if(result){
                        _this.saleMoneydata = numberformatter(Math.round(result.data.money))
                    }
                })
                memberTypeRate().then(function(result){

                    if(result){
                        var guideTotal = result.data.guideSaleVolume+result.data.memberBuyVolume
                        guideTotal = guideTotal>10000?(guideTotal/10000).toFixed(2)+'万':guideTotal
                        _this.guideAndMemberSaledata.text = "总计 "+guideTotal
                        _this.guideAndMemberSaledata.legendData = ["移动导购","静默会员"]
                        _this.guideAndMemberSaledata.data = [
                                                                {value: result.data.guideSaleVolume, name: '移动导购',itemStyle:{color:'#16CEB9'}},
                                                                {value: result.data.memberBuyVolume, name: '静默会员',itemStyle:{color:'#377DFF'}}
                                                            ]
                        var lineTotal = result.data.offlineSalesVolume+result.data.onlineSalesVolume
                        lineTotal = lineTotal>10000?(lineTotal/10000).toFixed(2)+'万':lineTotal
                        _this.onAndOffSaledata.text = "总计 "+lineTotal
                        _this.onAndOffSaledata.legendData = ["线上销售","线下销售"]
                        _this.onAndOffSaledata.data = [
                                                                {value: result.data.onlineSalesVolume, name: '线上销售',itemStyle:{color:'#F7517F'}},
                                                                {value: result.data.offlineSalesVolume, name: '线下销售',itemStyle:{color:'#6648FF'}}
                                                    ]
                    }
                    _this.memberTypeRateStatus = true;
                })
                produceAndSale().then(function(result){
                    _this.produceAndSaledata.header= ['图片', '货号', '新增投产','待回货', '昨日回货', '昨日入库','库存']
                    _this.produceAndSaledata.data = []
                    _this.produceAndSaledata.columnWidth = [50,100],
                    _this.produceAndSaledata.headerClass = 'header-production'
                    _this.produceAndSaledata.ceilClass = 'ceil-production'
                    _this.produceAndSaledata.align = ['center','left','left','left','left','left','center'],
                    _this.produceAndSaledata.headerBGC ='#03083A'
                    _this.produceAndSaledata.oddRowBGC ='rgba(0,0,0,0~1)'
                    _this.produceAndSaledata.evenRowBGC ='#03083A'
                    if(result){
                        result.data.list.forEach(function(item){
                            var imageUrl = JSON.parse(item.imageUrl)
                            if(imageUrl == null){
                                imageUrl = ['http://pim.gloria.com.cn/productImg/nopic.gif?x-oss-process=image/resize,w_78']
                            }
                            _this.produceAndSaledata.data.push(["<img src='"+imageUrl[0]+"'/>",item.itemId,item.producePlan,item.producing,item.returnAmount,item.inbound,item.stock])
                        })
                    }
                    _this.produceAndSaleStatus = true;
                })
                productTest().then(function(result){
                    _this.productTestdata.header= ['图片', '货号', '品类','订单量', '测款量', '已测款天数','销售量']
                    _this.productTestdata.data = []
                    _this.productTestdata.columnWidth = [50,90]
                    _this.productTestdata.headerClass = 'header-presale'
                    _this.productTestdata.ceilClass = 'ceil-presale'
                    _this.productTestdata.align = ['center','left','left','left','left','left','left']
                    _this.productTestdata.headerBGC ='#03083A'
                    _this.productTestdata.oddRowBGC ='rgba(0,0,0,0~1)'
                    _this.productTestdata.evenRowBGC ='#03083A'
                    if(result){
                        result.data.list.forEach(function(item){
                            var imageUrl = JSON.parse(item.imageUrl)
                            if(imageUrl == null){
                                imageUrl = ['http://pim.gloria.com.cn/productImg/nopic.gif?x-oss-process=image/resize,w_78']
                            }
                            _this.productTestdata.data.push(["<img src='"+item.imageUrl+"'/>",item.itemId,item.goodsClass,item.orderVolume,item.testVolume,item.testDays,item.saleVolume])
                        })
                    }
                    _this.productTestStatus = true;
                })
                registerMemberCount().then(function(result){
                    if(result){
                        _this.registerMemberCountdata = result.data.list
                    }
                    _this.registerMemberCountStatus = true;
                })
                storeSale().then(function(result){
                    if(result){                        
                        _this.storeSaledata = result.data
                    }
                })
                salesVolume().then(function(result){

                     // this.cchar2_data
                      _this.salesVolumeStatus = true;
                setTimeout(function(){
                  var obj={date:[],saleTotal:[]}
                    for(var i=0;i<result.data.list.length;i++){
                      obj.date.push(result.data.list[i].date)
                      obj.saleTotal.push(result.data.list[i].salesVolume)
                    }
                  _this.salesVolumedata=obj
                  _this.datelist2=obj.date
                  },0)
                    // if(result){
                    //     _this.salesVolumedata = result.data.list
                        
                    // }
                  
                })
                shopRank().then(function(result){
                    _this.shopRankdata.header= ['排名', '店铺', '销售额']
                    _this.shopRankdata.data = []
                    _this.shopRankdata.rowNum = 7
                    _this.shopRankdata.columnWidth = [50,130]
                    _this.shopRankdata.headerClass = 'header-shop-sale'
                    _this.shopRankdata.ceilClass = 'ceil-shop-sale'
                    _this.shopRankdata.align = ['center','left','right']
                    _this.shopRankdata.headerBGC ='#03083A'
                    _this.shopRankdata.oddRowBGC ='rgba(0,0,0,0~1)'
                    _this.shopRankdata.evenRowBGC ='rgba(0,0,0,0~1)'
                    if(result){
                        result.data.list.forEach(function(item){
                            if(item.rank <= 3 ){
                                _this.shopRankdata.data.push(["<img class='boardImg' src='" +_this.images[item.rank-1] +"' />",item.shopName,item.saleVolume])
                            }else {
                                _this.shopRankdata.data.push([item.rank,item.shopName,item.saleVolume])
                            }
                            
                        })
                    }
                    _this.shopRankStatus = true;
                })
                bigSale(5000).then(function(result){
                    if(result){
                       _this.bigSaledata =  result.data.list.length == 0?{}:result.data.list[0]
                       if(result.data.list.length > 0){
                           _this.fireworksStatus = true;
                           _this.timer1 = setInterval(_this.startFirework, 2000);
                           
                       }
                    }
                })
            
            },
            startFirework(){
                const _this = this
                _this.bigSaleStatus = true;
                if (_this.timer1) {
                    clearInterval(_this.timer1);
                }
                _this.timer1 = setInterval(_this.closeBigSale, 10000);
            },
            closeBigSale(){
                const _this = this
                _this.bigSaleStatus = false;
                if (_this.timer1) {
                    clearInterval(_this.timer1);
                }
                _this.timer1 = setInterval(_this.closeFirework, 2000);
            },
            closeFirework(){
                const _this = this
                _this.fireworksStatus = false;
                if (_this.timer1) {
                    clearInterval(_this.timer1);
                }
            }
        },
        beforeDestroy: function() {
       
            if (this.timer) {
                clearInterval(this.timer);
            }
        },
        components: {
            topHeader,
            wrapper,
            mhead,
            DigitalFlop,
            barChart,
            lineChart,
            pieChart,
            radiusPieChart,
            scrollBoard,
            mapChart,
            cusbox,
            custitle,
            boardNum,
            bigOrder,
            fireworks
        }
    }
</script>
<style lang="scss">
.xl_top50{
    
    .ceil-product-sale1,.ceil-production0{
        img{
            width: 60px !important;
            height: 60px !important;
        }
    }

    .row-item{
        .ceil{
         display: flex !important;
        align-items: center;
        }
     
    }
    }
    .device_phone{
       
        .header{
          display: flex;
         
        }
        .row-item{
            display: flex;
        }
         .mh1{
          .header-shop-sale{
              &0{
                flex:0.5
              }
              &1{
                flex:4
              }
              &2{
                flex:1;
                text-align: left;
              }             
          }
          .row-item{
              .ceil-shop-sale{
                &0{
                    flex:0.5
                }
                &1{
                    flex:4
                }
                &2{
                    flex:1;
                    text-align: left;
                }             
              }
          }          
        }
        .mh2{
          .header-guide-sale{
              &0{
                flex:0.5
              }
              &1{
                flex:4
              }
              &2{
                flex:2;
                text-align: left;
              }      
              &3{
                flex:1;
                text-align: left;
              }          
          }
          .row-item{
              .ceil-guide-sale{
                &0{
                    flex:0.5
                }
                &1{
                    flex:4
                }
                &2{
                    flex:2;
                    text-align: left;
                }    
                &3{
                    flex:1;
                    text-align: left;
                }              
              }
          }          
        }
        .mh3{
            .header-product-sale{
                &0{
                flex:0.5
              }
              &1{
                flex:1
              }
              &2{
                flex:4;
                text-align: left;
              }      
              &3{
                flex:1;
                text-align: left;
              }       
              &4{
                flex:1;
                text-align: left;
              }      
             &5{
                flex:2;
                text-align: left;
              }      
              &6{
                flex:2;
                text-align: left;
              }    
               &7{
                flex:1;
                text-align: left;
              }    
            }
            .ceil-product-sale{
             &0{
                flex:0.5;
                    justify-content: center;
              }
              &1{
                flex:1;
                    justify-content: center;
              }
              &2{
                flex:4;
                text-align: left;
              }      
              &3{
                flex:1;
                text-align: left;
              }       
              &4{
                flex:1;
                text-align: left;
              }      
             &5{
                flex:2;
                text-align: left;
              }      
              &6{
                flex:2;
                text-align: left;
              }    
               &7{
                flex:1;
                text-align: left;
              }    
            }

        }
        .mh4{
           .header-production{
              &0{
                flex:1
              }
              &1{
                flex:3
              }
              &2{
                flex:1;
                text-align: left;
              }      
              &3{
                flex:1;
                text-align: left;
              }       
              &4{
                flex:1;
                text-align: left;
              }      
             &5{
                flex:1;
                text-align: left;
              }      
              &6{
                flex:1;
                text-align: left;
              }      
            }
            .ceil-production{
&0{
                flex:1;
                align-items: center;
                justify-content: center;
              }
              &1{
                flex:3
              }
              &2{
                flex:1;
                text-align: left;
              }      
              &3{
                flex:1;
                text-align: left;
              }       
              &4{
                flex:1;
                text-align: left;
              }      
             &5{
                flex:1;
                text-align: left;
              }      
              &6{
                flex:1;
                text-align: left;
              }   
            }
        }

    }
</style>
<style lang='scss' scoped>
.device_phone{
    .header{
        background: yellowgreen !important;
    }
    .container1-chart-p{
        height: 100%;
        display: flex;
        flex-direction: column;
    }
    .container1-chart-pie{
        flex:1
    }
    .board{
                            margin-top: 13px;
                            width: 100%;
                            height: 100%;
                            .header{
                                height: 38px;
                                .header-item{
                                    height: 38px;
                                    line-height: 38px;
                                }
                                .header-shop-sale0{
                                    width:36px;
                                }
                                .header-shop-sale1{
                                    width: 178px;
                                }
                                .header-shop-sale2{
                                    width: 84px;
                                }
                                .header-guide-sale0{
                                    width: 36px;
                                }
                                .header-guide-sale1{
                                    width: 149px;
                                }
                                .header-guide-sale2{
                                    width: 58px;
                                }
                                .header-guide-sale3{
                                    width: 60px;
                                }
                                .header-product-sale0{
                                    width:8%;
                                }
                                .header-product-sale1{
                                    width:10%;
                                }
                                .header-product-sale2{
                                    width:16%;
                                }
                                .header-product-sale3{
                                    width:15%;
                                }
                                .header-product-sale4{
                                    width:10%;
                                }
                                .header-product-sale5{
                                    width:15%;
                                }
                                .header-product-sale6{
                                    width:12%;
                                }
                                .header-product-sale7{
                                    width:14%;
                                }
                                .header-presale0{
                                    width:10%;
                                }
                                .header-presale1{
                                    width:20%;
                                }
                                .header-presale2{
                                    width:10%;
                                }
                                .header-presale3{
                                    width:15%;
                                }
                                .header-presale4{
                                    width:15%;
                                }
                                .header-presale5{
                                    width:15%;
                                }
                                .header-presale6{
                                    width:15%;
                                }
                            }
                            .rows{
                                .row-item{
                                    height: 30px;
                                    line-height: 30px;
                                }
                                .ceil-shop-sale0{
                                    width: 12%;
                                }
                                .ceil-shop-sale1{
                                    width: 60%;
                                }
                                .ceil-shop-sale2{
                                    width: 28%;
                                }
                                .ceil-guide-sale0{
                                    width: 12%;
                                }
                                .ceil-guide-sale1{
                                    width: 50%;
                                }
                                .ceil-guide-sale2{
                                    width: 18%;
                                }
                                .ceil-guide-sale3{
                                    width: 20%;
                                }
                                .ceil-product-sale0{
                                    width:8%;
                                }
                                .ceil-product-sale1{
                                    width:10%;
                                    img{
                                        width: 12px ;
                                        height: 12px ;
                                    }
                                }
                                .ceil-product-sale2{
                                    width:16%;
                                }
                                .ceil-product-sale3{
                                    width:15%;
                                }
                                .ceil-product-sale4{
                                    width:10%;
                                }
                                .ceil-product-sale5{
                                    width:15%;
                                }
                                .ceil-product-sale6{
                                    width:12%;
                                }
                                .ceil-product-sale7{
                                    width:14%;
                                }
                                .ceil-presale0{
                                    width:10%;
                                    img{
                                        width: 12px ;
                                        height: 12px ;
                                    }
                                }
                                .ceil-presale1{
                                    width:20%;
                                }
                                .ceil-presale2{
                                    width:10%;
                                }
                                .ceil-presale3{
                                    width:15%;
                                }
                                .ceil-presale4{
                                    width:15%;
                                }
                                .ceil-presale5{
                                    width:15%;
                                }
                                .ceil-presale6{
                                    width:15%;
                                }
                            }
                        }
     .box2-top{
                        width: 100%;
                        height: 100%;
                        flex:1;
                        .container1-title{
                            font-family: PingFangSC-Semibold;
                            font-size: 20px;
                            color: #C0C8FF;
                            letter-spacing: 0;
                            text-align: center;
                            padding-top: 30px;
                        }
                        .container1-value{
                            width: 100%;
                            font-family: Gotham-Bold;
                            font-size: 60px;
                            line-height: 60px;
                            background-image:-webkit-linear-gradient(right,#EA2C5D,#FF9433,yellow);
                            -webkit-background-clip:text;
                            -webkit-text-fill-color:transparent;
                            letter-spacing: 0;
                            text-align: center;
                            padding-top: 10px;
                        }
                        .container1-center-box-digital{
                            width:100%;
                            height:70px;
                            margin-top:12.8px;
                            display: flex;
                        }
                        .container1-content{
                            font-family: PingFangSC-Semibold;
                            font-size: 14px;
                            color: #FFFFFF;
                            letter-spacing: 0;
                            text-align: center;
                            display: flex;
                            justify-content: space-between;
                            padding-left:120px;
                            padding-right: 120px;
                            margin-top: 10px;
                            ul{
                                display:normal;
                                list-style-type: disc;
                                margin-block-start: 0;
                                margin-block-end: 0;
                                margin-inline-start: 0px;
                                margin-inline-end: 0px;
                                padding-inline-start: 0px;
                                li{
                                    list-style: none;
                                    text-align: center;
                                    margin-bottom: 5px;
                                    font-family: PingFangSC-Semibold;
                                    font-size: 18px;
                                    color: #C0C8FF;
                                    letter-spacing: 0;
                                    text-align: center;
                                    span{
                                        font-family: Helvetica-Bold;
                                        font-size: 30px;
                                        color: #FFFFFF;
                                        letter-spacing: 0;
                                        text-align: center;
                                    }
                                }
                            }
                        }
                    }
                    .box2-bottom{
                        width: 100%;
                        height: 100%;
                        flex:3;
                        margin-top: 20px;
                        .container1-chart{
                            width:100%;
                            height: 100%;
                            position: relative;
                            .container1-chart-map{
                                width:100%;
                                height: 100%;
                                position: absolute;
                                top: -10px;
                            }
                            .map-value{
                                width:100%;
                                font-family: PingFangSC-Semibold;
                                font-size: 20px;
                                color: #E8E7FD;
                                letter-spacing: 0;
                                text-align: center;
                                bottom: 10px;
                                .map-icon{
                                    display:inline-block;
                                    border-radius: 50px;
                                    background: #F14949;
                                    padding: 3px;
                                    margin: 5px 8px;
                                }
                            }
                        }
                    }
    .container1-chart{
       height: 100%;
    }
}
</style>
<style lang="scss" type="text/css">
    *{
        box-sizing: border-box;
    }
    body,html{
        height: 100%;
    }
    .screen{
        background-size: 100% 100%;
        background-image: url(../../assets/bg.png);
        display: flex;
        flex-direction: column;
        height: 100%;
        min-width: 1280px;
        min-height: 720px;
        overflow: hidden;
        .rv{
           flex-direction: column;
        }
        .row.header{
            height: 80px;
            flex: none;
        }
        .row.container{
            flex-direction: column;
            padding: 8px 10px;      
        }
        .row{
            display:flex;
            flex:1;
            .col{  
                flex:1;
                display: flex;  
            }
            .col.col-1{
                // width:621px;
                height: 100%;
                flex:1;
                display: flex;
                .row1{
                    display: flex;
                    flex:1;
                    width: 100%;
                    height: 100%;
                    .box1-right{
                        margin-right: 13px;
                    }
                    .col.box1{
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        position: relative;
                        .container1-chart{
                            height: 100%;
                            .container1-chart-line{
                                width:100%;
                                height: 100%
                            }
                        }
                        .board{
                            margin-top: 13px;
                            width: 100%;
                            height: 100%;
                            .header{
                                height: 38px;
                                .header-item{
                                    height: 38px;
                                    line-height: 38px;
                                }
                                .header-shop-sale0{
                                    width:36px;
                                }
                                .header-shop-sale1{
                                    width: 178px;
                                }
                                .header-shop-sale2{
                                    width: 84px;
                                }
                                .header-guide-sale0{
                                    width: 36px;
                                }
                                .header-guide-sale1{
                                    width: 149px;
                                }
                                .header-guide-sale2{
                                    width: 58px;
                                }
                                .header-guide-sale3{
                                    width: 60px;
                                }
                                .header-product-sale0{
                                    width:8%;
                                }
                                .header-product-sale1{
                                    width:10%;
                                }
                                .header-product-sale2{
                                    width:16%;
                                }
                                .header-product-sale3{
                                    width:15%;
                                }
                                .header-product-sale4{
                                    width:10%;
                                }
                                .header-product-sale5{
                                    width:15%;
                                }
                                .header-product-sale6{
                                    width:12%;
                                }
                                .header-product-sale7{
                                    width:14%;
                                }
                                .header-presale0{
                                    width:10%;
                                }
                                .header-presale1{
                                    width:20%;
                                }
                                .header-presale2{
                                    width:10%;
                                }
                                .header-presale3{
                                    width:15%;
                                }
                                .header-presale4{
                                    width:15%;
                                }
                                .header-presale5{
                                    width:15%;
                                }
                                .header-presale6{
                                    width:15%;
                                }
                            }
                            .rows{
                                .row-item{
                                    height: 30px;
                                    line-height: 30px;
                                }
                                .ceil-shop-sale0{
                                    width: 12%;
                                }
                                .ceil-shop-sale1{
                                    width: 60%;
                                }
                                .ceil-shop-sale2{
                                    width: 28%;
                                }
                                .ceil-guide-sale0{
                                    width: 12%;
                                }
                                .ceil-guide-sale1{
                                    width: 50%;
                                }
                                .ceil-guide-sale2{
                                    width: 18%;
                                }
                                .ceil-guide-sale3{
                                    width: 20%;
                                }
                                .ceil-product-sale0{
                                    width:8%;
                                }
                                .ceil-product-sale1{
                                    width:10%;
                                    img{
                                        width: 38px;
                                        height: 38px;
                                    }
                                }
                                .ceil-product-sale2{
                                    width:16%;
                                }
                                .ceil-product-sale3{
                                    width:15%;
                                }
                                .ceil-product-sale4{
                                    width:10%;
                                }
                                .ceil-product-sale5{
                                    width:15%;
                                }
                                .ceil-product-sale6{
                                    width:12%;
                                }
                                .ceil-product-sale7{
                                    width:14%;
                                }
                                .ceil-presale0{
                                    width:10%;
                                    img{
                                        width: 38px;
                                        height: 38px;
                                    }
                                }
                                .ceil-presale1{
                                    width:20%;
                                }
                                .ceil-presale2{
                                    width:10%;
                                }
                                .ceil-presale3{
                                    width:15%;
                                }
                                .ceil-presale4{
                                    width:15%;
                                }
                                .ceil-presale5{
                                    width:15%;
                                }
                                .ceil-presale6{
                                    width:15%;
                                }
                            }
                        }
                    }
                }
                .row1.row-center{
                    padding:13px 0;
                    .col.box1{
                        max-width: 310px;
                    }
                }
                .row1.row-left{
                    height: 269px;
                }
            }
            .col.col-2{
                // width:616px;
                height: 100%;
                flex:1;
                display: flex;
                flex-flow: row wrap;
                padding: 0 13px 0px 13px;
                // margin-top: 10px;
                .col.box2{
                    flex:1;
                    display: flex;
                    width: 100%;
                    height: 100%;
                    .box2-top{
                        width: 100%;
                        height: 100%;
                        flex:0.8;
                        .container1-title{
                            font-family: PingFangSC-Semibold;
                            font-size: 20px;
                            color: #C0C8FF;
                            letter-spacing: 0;
                            text-align: center;
                            padding-top: 30px;
                        }
                        .container1-value{
                            width: 100%;
                            font-family: Gotham-Bold;
                            font-size: 60px;
                            line-height: 60px;
                            background-image:-webkit-linear-gradient(right,#EA2C5D,#FF9433,yellow);
                            -webkit-background-clip:text;
                            -webkit-text-fill-color:transparent;
                            letter-spacing: 0;
                            text-align: center;
                            padding-top: 10px;
                        }
                        .container1-center-box-digital{
                            width:100%;
                            height:70px;
                            margin-top:12.8px;
                            display: flex;
                        }
                        .container1-content{
                            font-family: PingFangSC-Semibold;
                            font-size: 14px;
                            color: #FFFFFF;
                            letter-spacing: 0;
                            text-align: center;
                            display: flex;
                            justify-content: space-between;
                            padding-left:120px;
                            padding-right: 120px;
                            margin-top: 10px;
                            ul{
                                display:normal;
                                list-style-type: disc;
                                margin-block-start: 0;
                                margin-block-end: 0;
                                margin-inline-start: 0px;
                                margin-inline-end: 0px;
                                padding-inline-start: 0px;
                                li{
                                    list-style: none;
                                    text-align: center;
                                    margin-bottom: 5px;
                                    font-family: PingFangSC-Semibold;
                                    font-size: 18px;
                                    color: #C0C8FF;
                                    letter-spacing: 0;
                                    text-align: center;
                                    span{
                                        font-family: Helvetica-Bold;
                                        font-size: 30px;
                                        color: #FFFFFF;
                                        letter-spacing: 0;
                                        text-align: center;
                                    }
                                }
                            }
                        }
                    }
                    .box2-bottom{
                        width: 100%;
                        height: 100%;
                        flex:1.2;
                        margin-top: 20px;
                        .container1-chart{
                            width:100%;
                            height: 100%;
                            position: relative;
                            .container1-chart-map{
                                width:100%;
                                height: 100%;
                                position: absolute;
                                top: -10px;
                            }
                            .map-value{
                                width:100%;
                                font-family: PingFangSC-Semibold;
                                font-size: 20px;
                                color: #E8E7FD;
                                letter-spacing: 0;
                                text-align: center;
                                bottom: 10px;
                                .map-icon{
                                    display:inline-block;
                                    border-radius: 50px;
                                    background: #F14949;
                                    padding: 3px;
                                    margin: 5px 8px;
                                }
                            }
                        }
                    }
                    // .map-chart-title{
                    //     width:100%;
                    //     height: 100%;
                    //     flex:0.2;
                    //     text-align: center;
                    //     font-family: PingFangSC-Semibold;
                    //     font-size: 20px;
                    //     color: #E8E7FD;
                    //     letter-spacing: 0;
                    //     text-align: center;
                    // }
                }
            }
            .col.col-3{
                // width:618px;
                height: 100%;
                flex:1;
                display: flex;
                .row3{
                    flex:1;
                    display: flex;
                    width: 100%;
                    height: 100%;
                    .container1-right-box-chart{
                            display: flex;
                            height: 100%;
                            .container1-right-box-chart-pie{
                                width: 100%;
                                height: 100%;
                            }
                    }
                    .container1-right-box-board{
                            width: calc(100% - 10px);
                            height: 100%;
                            margin-top: 13px;
                            .header{
                                height: 38px;
                                .header-item{
                                    height: 38px;
                                    line-height: 38px;
                                }
                                .header-production0{
                                    width:10%;
                                }
                                .header-production1{
                                    width:20%;
                                }
                                .header-production2{
                                    width:15%;
                                }
                                .header-production3{
                                    width:15%;
                                }
                                .header-production4{
                                    width:15%;
                                }
                                .header-production5{
                                    width:15%;
                                }
                                .header-production6{
                                    width:10%;
                                }
                            }
                            .rows{
                                .ceil-production0{
                                    width:10%;
                                    img{
                                        width: 38px;
                                        height: 38px;
                                    }
                                }
                                .ceil-production1{
                                    width:20%;
                                }
                                .ceil-production2{
                                    width:15%;
                                }
                                .ceil-production3{
                                    width:15%;
                                }
                                .ceil-production4{
                                    width:15%;
                                }
                                .ceil-production5{
                                    width:15%;
                                }
                                .ceil-production6{
                                    width:10%;
                                }
                            }
                    }
                    .container2-box-pie{
                        width: 100%;
                        height: 100%;
                    }
                }
                .row3.row-center{
                    padding:13px 0;
                }
            }
        }
        .dv-decoration-3{
            width:auto;
            height:30px;
            padding:15px;
        }
        .boardImg{
            width: 18px;
            height: 18px;
        }

        
    }
</style>